module.exports = "/_next/static/images/vertcoin-b693c863fb43bc3c3ac4d96d340acf36.png";